import styled from "styled-components";

export const ActivityLogContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
`;

export const UserCellContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const UserAvatarContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const UserTextContainer = styled.div`
  display: flex;
  align-items: center;
`;
